import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ContentViewer from "../../components/ContentViewer/ContentViewer";
import { pollForCompletion } from "../../services/temporaryVisionCallService";
import Banner from "../../components/Banner/Banner";
import { Box, Typography } from "@mui/material";
import { fetchContentable } from "../../redux/actions/learningCenter/contentableActions";
import { fetchData } from "../../redux/actions/learningCenter/activityActions";
import { setExpandedList } from "../../redux/actions/learningCenter/expandedAssignmentsActions";
import { updateQuizAnswer } from "../../redux/actions/learningCenter/quizActions";
import { browserWSSupport } from "../../utils/webSockets";
import { makeGetEntities } from "../../redux/selectors/selectors";
import LoadingSpinnerWithBackdrop from "../../components/LoadingSpinner/LoadingSpinnerWithBackdrop";

const selector = makeGetEntities();

const pollInterval = 10000; // 10 seconds

const NoContentView = () => {
  return (
    <Box
      height={380}
      mt={2}
      mb={4}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      flex={1}
    >
      <Banner gradientDirection="rtl" ellipseBackground="right">
        <Box
          display="flex"
          height="100%"
          alignItems="center"
          pl={{ xs: 2, sm: 3, md: 11.5 }}
          pr={2}
        >
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            color="white"
          >
            <Typography variant="h5">
              You do not have an active assignment for this course or
              permissions to view it. Please contact your training administrator
              for more information.
            </Typography>
          </Box>
        </Box>
      </Banner>
    </Box>
  );
};

// TODO: Refactor this component to avoid prop spreading into the content viewer component
const ContentViewerContainer = ({
  setExpandedList,
  courseId,
  fetchContentable,
  fetchData,
  match: {
    params: { course_contentable_id, user_assignment_id }
  },
  activityData,
  nextActivity,
  prevActivity,
  contentable,
  user,
  updateQuizAnswer,
  history
}) => {
  const [noContent, setNoContent] = useState(false);
  const [loading, setLoading] = useState(true);
  const checkForCompletion = () => {
    return pollForCompletion([courseId]);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!browserWSSupport) {
        checkForCompletion();
      }
    }, pollInterval);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchContentable(course_contentable_id).catch(error => {
      console.log(error);
      setNoContent(true);
    });
    fetchData(user_assignment_id, course_contentable_id)
      .then(activity => {
        if (!nextActivity && activity.nextId) {
          fetchData(user_assignment_id, activity.nextId, true);
        }
        if (!prevActivity && activity.previousId) {
          fetchData(user_assignment_id, activity.previousId, true);
        }
        setLoading(false);
        return activity;
      })
      .catch(error => {
        console.log(error);
        setNoContent(true);
      });
  }, [course_contentable_id]);

  const handleAddToExpandedCoursesList = assignment => {
    setExpandedList(assignment, true);
  };

  return loading ? (
    <LoadingSpinnerWithBackdrop />
  ) : noContent ? (
    <NoContentView />
  ) : (
    <ContentViewer
      activityData={activityData}
      contentable={contentable}
      user={user}
      onAddToExpandedCoursesList={handleAddToExpandedCoursesList}
      checkForCompletion={() => checkForCompletion()}
      fetchData={fetchData}
      updateQuizAnswer={updateQuizAnswer}
      history={history}
    />
  );
};

const makeMapStateToProps = () => {
  const mapStateToProps = (
    state,
    {
      match: {
        params: { course_contentable_id }
      }
    }
  ) => {
    const activityData = selector(state.learningCenterActivityData, {
      type: "activity",
      id: course_contentable_id
    });

    const nextActivity =
      activityData && activityData.nextId
        ? selector(state.learningCenterActivityData, {
            type: "activity",
            id: activityData.nextId
          })
        : null;

    const prevActivity =
      activityData && activityData.previousId
        ? selector(state.learningCenterActivityData, {
            type: "activity",
            id: activityData.previousId
          })
        : null;

    const homework = activityData
      ? selector(state.learningCenter.contentable, {
          type: "contentable",
          id: activityData.contentableId
        })
      : null;

    const quiz = state.learningCenter.contentable.quiz;
    return {
      // This is a temp solution to safely handle the quiz contentable until it is refactored to follow the JSON API spec
      contentable: homework || quiz || {},
      user: state.userState.user,
      activityData,
      prevActivity,
      nextActivity
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  fetchContentable,
  fetchData,
  updateQuizAnswer,
  setExpandedList
})(ContentViewerContainer);
